import { Component, OnInit } from '@angular/core';
import { TipStrucnogUsavrsavanja } from './tip-strucnog-usavrsavanja';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-tipstrucnogusavrsavanja',
  templateUrl: './tip-strucnog-usavrsavanja.component.html'
})
export class TipStrucnogUsavrsavanjaComponent extends BaseModalContainer<TipStrucnogUsavrsavanja> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<TipStrucnogUsavrsavanja>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }


  ngOnInit() {
  }

}
